export default __webpack_public_path__ + "a7d6f67ab89353d3fb3d3ae6a9c6f7b0.svg";